
























































































import { getUserData } from "@/auth/getUserData";
import useParseMessage from "@/composables/v2.1/useParseMessage";
import useTemplates from "@/composables/v3/useTemplates";
import { ParseMessagesInterface } from "@/interfaces/parseMessages.interface";
import { useChatsStore } from "@/store/useChatsStore";
import { useContactsStore } from "@/store/useContactsStore";
// @ts-ignore
import { addDataToInput } from "@/utils/input";
// @ts-ignore
import { required } from "@validations";
import { defineComponent, onMounted, ref } from "@vue/composition-api";
import {
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,
    BSpinner,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// @ts-ignore
import emojiPicker from "./emojiPicker.vue";

export default defineComponent({
    components: {
        ValidationProvider,
        ValidationObserver,
        required,
        BCardText,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BCard,
        BCardBody,
        BOverlay,
        BSpinner,
        emojiPicker,
    },
    methods: {
        validationForm() {
            this.isLoadingSubmit = true;

            // @ts-ignore
            this.$refs.simpleRules.validate().then(async (success) => {
                if (success) {
                    this.selectedTemplate.content = this.selectedTemplate.final;
                    this.setChatInputTemplate(this.selectedTemplate);

                    this.isLoadingSubmit = false;
                }
            });
        },
    },
    setup() {
        const isLoadingMessageExample = ref(false);
        const isLoadingSubmit = ref(false);

        const chatsStore = useChatsStore();
        const contactsStore = useContactsStore();
        const { variablesToIndex, selectedTemplate, resetTemplate, setChatInputTemplate } = useTemplates();

        const { parseMessage } = useParseMessage();

        // @ts-ignore
        selectedTemplate.value.indexed = variablesToIndex(selectedTemplate.value.originalContent);

        onMounted(async () => {
            isLoadingMessageExample.value = true;
            // @ts-ignore
            const parsedMessage = await parseMessage({
                inputMessage: selectedTemplate.value.content,
                parseData: {
                    contact: contactsStore.activeChatContact?.id,
                    assignedAgent: chatsStore.activeChat?.chat.assignedUserId,
                    sendingAgent: getUserData(),
                },
            } as ParseMessagesInterface);

            selectedTemplate.value.variables.forEach((variable: any) => {
                const parsedVariable =
                    parsedMessage.variables[variable.name.substring(2, variable.name.length - 2).trim()];

                if (!parsedVariable) {
                    return;
                }

                variable.value = parsedVariable;
            });

            // @ts-ignore
            selectedTemplate.value.content = selectedTemplate.value.indexed;
            selectedTemplate.value.content = selectedTemplate.value.content.replace(/{{\s*([^}]*)\s*}}/g, (_, $1) => {
                return selectedTemplate.value.variables[$1 - 1].value;
            });

            selectedTemplate.value = {
                ...selectedTemplate.value,
                final: selectedTemplate.value.content,
            };

            isLoadingMessageExample.value = false;
        });

        const input = (name: string, index: number, event: unknown) => {
            selectedTemplate.value.variables[index - 1] = {
                index,
                name,
                value: event,
            };

            // @ts-ignore
            selectedTemplate.value.content = selectedTemplate.value.indexed;

            selectedTemplate.value.content = selectedTemplate.value.content.replace(/{{\s*([^}]*)\s*}}/g, (_, $1) => {
                return selectedTemplate.value.variables[$1 - 1].value;
            });

            selectedTemplate.value = {
                ...selectedTemplate.value,
                final: selectedTemplate.value.content,
            };
        };

        const selectEmoji = (emoji: any, variable: any) => {
            const newValue = addDataToInput(
                `var-${variable.index}`,
                selectedTemplate.value.variables[variable.index - 1].value || "",
                emoji.data
            );

            selectedTemplate.value.variables[variable.index - 1].value = newValue;
            input(variable.name, variable.index, newValue);
        };

        return {
            setChatInputTemplate,
            resetTemplate,
            selectedTemplate,
            input,
            selectEmoji,
            isLoadingMessageExample,
            isLoadingSubmit,
        };
    },
});
